import { useCallback, useEffect, useRef } from "react";

const OTP_INACTIVITY_TIMEOUT_MS = 90000;

export function useOtpInactivityTimer({
  otpValue,
  isAuthorizing,
  isPolling,
  isActive,
  onTimeout,
}) {
  const timerRef = useRef(null);
  const hasAttemptedRef = useRef(false);
  const onTimeoutRef = useRef(onTimeout);

  useEffect(() => {
    onTimeoutRef.current = onTimeout;
  }, [onTimeout]);

  const stopTimer = useCallback(() => {
    clearTimeout(timerRef.current);
  }, []);

  const resetTimer = useCallback(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onTimeoutRef.current();
    }, OTP_INACTIVITY_TIMEOUT_MS);
  }, []);

  useEffect(() => {
    if (!isActive) {
      stopTimer();
      hasAttemptedRef.current = false;
      return;
    }
    resetTimer();
    return stopTimer;
  }, [isActive, resetTimer, stopTimer]);

  useEffect(() => {
    if (!isActive || !otpValue) return;
    resetTimer();
  }, [otpValue, isActive, resetTimer]);

  useEffect(() => {
    if (isAuthorizing) {
      hasAttemptedRef.current = true;
      stopTimer();
      return;
    }
    if (isPolling) {
      stopTimer();
      return;
    }
    if (hasAttemptedRef.current && isActive) {
      resetTimer();
    }
  }, [isAuthorizing, isPolling, isActive, stopTimer, resetTimer]);

  return { resetTimer };
}
